export const Normalizer = {
  fetch: data => ({
    ...data,
    fields: {
      ...data.fields,
      Name: data.fields.Name || '',
      Active: data.fields.Active === 'Yes',
    },
  }),

  send: values => {
    const params = {};
    Object.keys(values)
      .filter(k => values[k] !== null)
      .forEach(k => {
        if (k === 'Active') {
          params[k] = values[k] ? 'Yes' : 'No';
        } else {
          params[k] = values[k];
        }
      });

    return params;
  },
};
